<div class="swatches" role="radiogroup" [attr.aria-label]="'palette.label' | translate">
    <button
        *ngFor="let swatch of swatches"
        type="button"
        role="radio"
        class="swatch"
        [class.chosen]="isChosen(swatch)"
        [attr.aria-checked]="isChosen(swatch)"
        [attr.aria-label]="swatch.name"
        [title]="swatch.name"
        [style.--swatch]="swatch.hex"
        [disabled]="disabled"
        (click)="choose(swatch)"
        ></button>
</div>

<div class="caption">
    <ng-container *ngIf="chosenName">{{ chosenName }}</ng-container>
    <ng-container *ngIf="outsidePalette">
        <span class="swatch small" [style.--swatch]="value"></span>
        {{ "palette.notInPalette" | translate }}
    </ng-container>
</div>
